import React, { Component, cloneElement, useState } from "react";
import {
  List,
  CreateButton,
  Datagrid,
  downloadCSV,
  TextField,
  BooleanField,
  DateField,
  SelectInput,
  EditButton,
  DeleteButton,
  Button,
  TopToolbar,
  required,
  RefreshButton,
  ExportButton,
  Filter,
  TextInput,
  GET_ONE,
  useRecordContext,
  useResourceContext,
  ShowButton
} from "react-admin";
import { Link } from 'react-router-dom';
import { Scrollbars } from "react-custom-scrollbars";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption , getLocalStorageKey } from "../common/common";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import Spinner from "../../src/spinner";
import myDataProvider from "../myRestProvider";
import moment from "moment";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useLocation } from "react-router-dom";

const selectInputStyle = {
  width: 220,
};

const SalesOfficersFilter = (props) => (
  <Filter {...props}>
    <TextInput source="sales_officer_username" label="Sales Officers Name" />
    <TextInput source="sales_officer_email" label="Sales Officers Email" />
    <TextInput source="sales_officer_phone" label="Sales Officers phone" />
    <SelectInput
      style={selectInputStyle}
      source="sales_officer_status"
      label="Sales Officers Status"
      choices={[
        { id: true, name: "True" },
        { id: false, name: "False" },
      ]}
      validate={required()}
    />
    <TextInput source="business_name" label="Sold To Name" />
    <TextInput source="business_sap_code" label="Sold To Id" />
  </Filter>
);

const StatusField = ({ source }) => {
  const record = useRecordContext();
  return (
    <span>{record.sales_officer_status === null ? "-" : record.sales_officer_status === true ? "True" : "False"}</span>
  );
};

const TradeDeveloperField = ({ source }) => {
  const record = useRecordContext();
  return (
    <span>{record.is_trade_developer === null ? "-" : record.is_trade_developer === true ? "True" : "False"}</span>
  );
};

const UserName = () => {
  const record = useRecordContext();
  return (
    <span>
      {record && record.sales_officer_username
        ? `${record.sales_officer_username}`
        : "-"}
    </span>
  );
};


// class ListActions extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       modalShow: false,
//       modalMsg: "",
//       customFilterUrl:
//         'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D',
//     };
//   }

//   callExport = (e) => {
//     const options = CommonHeaderOption();
//     const apiUrl = RUN_TIME_API_ENDPOINT;
//     e.preventDefault();
//     console.log(
//       "...",
//       window.location.href,
//       `${apiUrl}/${this.props.resource}_csv`
//     );
//     options.method = "GET";
//     let _url = window.location.href.split("?");
//     if (_url.length > 1 && _url[1] !== "") {
//       console.log("params found");
//       this.setState({ customFilterUrl: _url[1] }, () => {
//         fetch(
//           `${apiUrl}/${this.props.resource}_csv?${this.state.customFilterUrl}`,
//           options
//         )
//           .then((res) => {
//             return res.json();
//           })
//           .then((jsonD) => {
//             console.log("json= inside callback", jsonD.data);
//             const msg = jsonD.data ? jsonD.data[0].message : "";
//             Swal.fire({
//               html: msg,
//               icon: "success",
//             });
//             // this.setState({ modalShow: true});
//             // this.setState({ modalMsg: msg});
//           });
//       });
//     } else {
//       this.setState(
//         {
//           customFilterUrl:
//             'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D',
//         },
//         () => {
//           fetch(
//             `${apiUrl}/${this.props.resource}_csv?${this.state.customFilterUrl}`,
//             options
//           )
//             .then((res) => {
//               return res.json();
//             })
//             .then((jsonD) => {
//               console.log("json= inside callback", jsonD.data);
//               const msg = jsonD.data ? jsonD.data[0].message : "";
//               Swal.fire({
//                 html: msg,
//                 icon: "success",
//               });
//               // this.setState({ modalShow: true});
//               // this.setState({ modalMsg: msg});
//             });
//         }
//       );
//     }
//   };
//   exporterModal = () => {
//     return "";
//   };

//   onClose = () => {
//     this.setState({ modalShow: false });
//   };
//   render() {
//     const {
//       resource,
//       filterValues,
//       total,
//       maxResults,
//       currentSort,
//       exporter,
//       permanentFilter,
//       showFilter,
//       displayedFilters,
//       filters,
//       basePath,
//     } = this.props;
//     const csvResource = resource + "_csv";
//     return (
//       <React.Fragment>
//         <TopToolbar>
//           {filters &&
//             cloneElement(filters, {
//               resource,
//               showFilter,
//               displayedFilters,
//               filterValues,
//               context: "button",
//             })}
//           <CreateButton basePath={basePath} />
//           <RefreshButton />
//           {/* <ExportButton
//         onClick={(e) => this.callExport(e)}
//         disabled={total === 0}
//         resource={csvResource}
//         sort={currentSort}
//         filter={{ ...filterValues, ...permanentFilter }}
//         exporter={this.exporterModal}
//         maxResults={maxResults}
//         /> */}
//           <div>
//             <button
//               className="export-button"
//               onClick={(e) => this.callExport(e)}
//               disabled={total === 0}
//               sort={currentSort}
//               filter={{ ...filterValues, ...permanentFilter }}
//             >
//               {<GetAppIcon />}
//               <span>Export</span>
//             </button>
//           </div>
//         </TopToolbar>
//         {this.state.modalShow && (
//           <Modal open={this.state.modalShow} onClose={this.onClose} center>
//             <h3>{this.state.modalMsg}</h3>
//           </Modal>
//         )}
//       </React.Fragment>
//     );
//   }
// }

const ListActions = (props) => {
  const location = useLocation();
  const resource = useResourceContext();

  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [customFilterUrl, setCustomFilterUrl] = useState(
    location.search
  );

  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    console.log("...", location.pathname, `${apiUrl}/${resource}_csv`);
    options.method = "GET";
    let _url = location.pathname.split("?");
    if (_url.length > 1 && _url[1] !== "") {
      console.log("params found");
      setCustomFilterUrl(_url[1]);
      fetch(`${apiUrl}/${resource}_csv?${_url[1]}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
          // this.setState({ modalShow: true});
          // this.setState({ modalMsg: msg});
        });
    } else {
      setCustomFilterUrl(
        location.search
      );
      fetch(
        `${apiUrl}/${resource}_csv?${location.search}`,
        options
      )
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
          // this.setState({ modalShow: true});
          // this.setState({ modalMsg: msg});
        });

      // this.setState(
      //   {
      //     customFilterUrl:
      //       'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D',
      //   },
      //   () => {
      //     fetch(
      //       `${apiUrl}/${props.resource}_csv?${customFilterUrl}`,
      //       options
      //     )
      //       .then((res) => {
      //         return res.json();
      //       })
      //       .then((jsonD) => {
      //         console.log("json= inside callback", jsonD.data);
      //         const msg = jsonD.data ? jsonD.data[0].message : "";
      //         Swal.fire({
      //           html: msg,
      //           icon: "success",
      //         });
      //         // this.setState({ modalShow: true});
      //         // this.setState({ modalMsg: msg});
      //       });
      //   }
      // );
    }
  };
  // exporterModal = () => {
  //   return "";
  // };

  const onClose = () => {
    // this.setState({ modalShow: false });
    setModalShow(false);
  };
  const {
    filterValues,
    total,
    maxResults,
    currentSort,
    exporter,
    permanentFilter,
    showFilter,
    displayedFilters,
    filters,
    basePath,
  } = props;
  const csvResource = resource + "_csv";
  return (
    <React.Fragment>
      <TopToolbar>
        {filters &&
          cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: "button",
          })}
        <RefreshButton />
        <CreateButton basePath={basePath} />
        {/* <ExportButton
            onClick={(e) => this.callExport(e)}
            disabled={total === 0}
            resource={csvResource}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
            exporter={this.exporterModal}
            maxResults={maxResults}
          /> */}
        <div>
          <button
            className="export-button"
            onClick={(e) => callExport(e)}
            disabled={total === 0}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
          >
            {<GetAppIcon />}
            <span>Export</span>
          </button>
        </div>
      </TopToolbar>
      {modalShow && (
        <Modal open={modalShow} onClose={onClose} center>
          <h3>{modalMsg}</h3>
        </Modal>
      )}
    </React.Fragment>
  );
};

const CustomShowButton = () => {
  const record = useRecordContext();
  return (
      <Button
          component={Link}
          to={{
              pathname: '/sales_officers/'+record.sales_officer_id+'/show',
          }}
      >
          Show
      </Button>
  )
}

const CustomEditButton = () => {
  const record = useRecordContext();
  return (
      <Button
          component={Link}
          to={{
              pathname: '/sales_officers/'+record.sales_officer_id,
          }}
      >
          Edit
      </Button>
  )
}


const SalesOfficersList = (props, permissions) => {
  let locale = getLocalStorageKey("locale");
  // const [moodalShow, setMoodalShow] = useState(false);
  // const [modalMsg, setModalMsg] = useState('');

  const exporter = (data) => {
    // const msg = data[0].message;
    // setModalMsg(true);
    // setModalMsg(msg);
    return "";
  };

  // const onClose = () => {
  //   setMoodalShow(false);
  // }

  // render() {
  // const { state, props, permissions } = this;
  return (
    <React.Fragment>
      <Scrollbars className="scroll-container">
        <List
          {...props}
          exporter={exporter}
          sort={{ field: "sales_officer_created_at", order: "DESC" }}
          filters={<SalesOfficersFilter />}
          title="Sales Officers"
          actions={<ListActions permissions={props} />}
        >
          <Datagrid bulkActionButtons={false} rowClick={false}>
            <UserName label="Sales Officers Name" />
            <TextField
              source="sales_officer_email"
              label="Sales Officers Email"
            />
            <TextField
              source="sales_officer_phone"
              label="Sales Officers phone"
            />
            <TextField source="business_sap_code" label="Sold To ID" />
            {
              locale == 'en-KE' &&
              <TradeDeveloperField source="is_trade_developer" label="Is Trade Developer" />
            }
            <TextField source="business_name" label="Sold To Name" />
            <StatusField source="sales_officer_status" label="Login Enabled" />
            <DateField
              source="sales_officer_created_at"
              label="Sales Officers created_at"
              showTime={true}
            />
            <CustomShowButton/>
            <CustomEditButton/>
            {/* <EditButton /> */}
            <DeleteButton />
          </Datagrid>
        </List>
      </Scrollbars>
      {/* {
          moodalShow &&
          <Modal open={moodalShow} onClose={onClose} center>
            <h3>{modalMsg}</h3>
          </Modal>
        } */}
    </React.Fragment>
  );
  // }
};

export default SalesOfficersList;
